import { showAlert } from "@erp/shared/utils/dialog";
import { cookiesConf } from "@erp/shared/const/cookies";
import { setCookie } from "../cookie/setCookie";
import { deleteCookie } from "../cookie/deleteCookie";
import { login } from "@erp/shared/api/generated/wrappers/auth";
import { clearAccessToken, clearRefreshToken, setAccessToken, setRefreshToken, } from "./token";
import { movePage } from "../router/movePage";
import { useUserInitStore } from "@erp/shared/stores";
import { logout } from "@erp/shared/api/generated/wrappers/auth";
/**
 * @description 로그인 함수
 *
 * @param id
 * @param pw
 * @param checkbox
 */
export const userLogin = async (id, pw, checkbox = false) => {
    if (checkbox) {
        setCookie(cookiesConf.savedID.key, id);
    }
    else {
        deleteCookie(cookiesConf.savedID.key);
    }
    // 로그인 API 호출
    const res = await login(id, pw);
    if (res.type === "normal") {
        const { accessToken, refreshToken } = res;
        setAccessToken(accessToken);
        setRefreshToken(refreshToken);
        movePage("/home");
    }
    else {
        showAlert("임시 비밀번호 상태입니다. 새 비밀번호를 설정해주세요.");
        movePage(`/change-tmp-password?userLoginId=${btoa(id)}&temporary_password=${btoa(pw)}`);
    }
};
export const userLogout = async () => {
    const userInitStore = useUserInitStore();
    userInitStore.setUser(null);
    userInitStore.setAllowedMenus([]);
    try {
        await logout();
    }
    catch (error) {
        console.error("로그아웃 API 호출 실패:", error);
    }
    finally {
        clearAccessToken();
        clearRefreshToken();
        const modal = showAlert("로그아웃되었습니다!", "로그아웃", 3000);
        modal.$on("close", () => {
            movePage("/");
        });
    }
};
